import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/PTZ/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SetPtzPerm';
import PTZTable01 from 'components/Web_User_Interface/1440p_Series/Features/PTZ/ptz01Table';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  PTZTable01,
  BreadCrumbs,
  SEOHelmet,
  React
};